import { render, staticRenderFns } from "./StandarPageEmptyState.vue?vue&type=template&id=2f20a54f&scoped=true"
import script from "./StandarPageEmptyState.vue?vue&type=script&lang=js"
export * from "./StandarPageEmptyState.vue?vue&type=script&lang=js"
import style0 from "./StandarPageEmptyState.vue?vue&type=style&index=0&id=2f20a54f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f20a54f",
  null
  
)

export default component.exports